import React, { useState, useEffect } from 'react';
import { adminLogout } from '../../api/admin';
import { useReminders } from './useReminders';
import ReminderBell from './ReminderBell';
import ReminderToast from './ReminderToast';
import './AdminLayout.css';

// SVG Icons
const Icons = {
  Dashboard: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
    </svg>
  ),
  Inquiries: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ),
  Services: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22c3.314 0 6-2.686 6-6 0-3.314-2.686-6-6-6C8.686 10 6 12.686 6 16c0 3.314 2.686 6 6 6z" />
      <path d="M12 10V4" />
      <path d="M8 8l4-4 4 4" />
    </svg>
  ),
  Projects: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
      <line x1="9" y1="22" x2="9" y2="18" />
      <line x1="15" y1="22" x2="15" y2="18" />
      <line x1="9" y1="14" x2="9" y2="10" />
      <line x1="15" y1="14" x2="15" y2="10" />
    </svg>
  ),
  Products: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
      <line x1="12" y1="22.08" x2="12" y2="12" />
    </svg>
  ),
  Gallery: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <polyline points="21 15 16 10 5 21" />
    </svg>
  ),
  Sliders: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="4" y1="21" x2="4" y2="14" />
      <line x1="4" y1="10" x2="4" y2="3" />
      <line x1="12" y1="21" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12" y2="3" />
      <line x1="20" y1="21" x2="20" y2="16" />
      <line x1="20" y1="12" x2="20" y2="3" />
      <line x1="2" y1="14" x2="6" y2="14" />
      <line x1="10" y1="12" x2="14" y2="12" />
      <line x1="18" y1="16" x2="22" y2="16" />
    </svg>
  ),
  Testimonials: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
  Clients: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  Settings: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  ),
  Website: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  Logout: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  ),
  Toggle: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  ),
  Logo: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22c3.314 0 6-2.686 6-6 0-3.314-2.686-6-6-6C8.686 10 6 12.686 6 16c0 3.314 2.686 6 6 6z" />
      <path d="M12 10V4" />
      <path d="M8 8l4-4 4 4" />
    </svg>
  ),
};

const NAV_ITEMS = [
  { path: '/admin/dashboard', icon: Icons.Dashboard, label: 'Dashboard' },
  { path: '/admin/inquiries', icon: Icons.Inquiries, label: 'Inquiries' },
  { path: '/admin/services', icon: Icons.Services, label: 'Services' },
  { path: '/admin/projects', icon: Icons.Projects, label: 'Projects' },
  { path: '/admin/products', icon: Icons.Products, label: 'Products' },
  { path: '/admin/gallery', icon: Icons.Gallery, label: 'Gallery' },
  { path: '/admin/sliders', icon: Icons.Sliders, label: 'Sliders' },
  { path: '/admin/testimonials', icon: Icons.Testimonials, label: 'Testimonials' },
  { path: '/admin/clients',   icon: Icons.Clients,   label: 'Clients'  },
  { path: '/admin/settings',  icon: Icons.Settings,  label: 'Settings' },
];

function AdminLayout({ children, title }) {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [admin, setAdmin] = useState(null);
  const current = window.location.pathname;
  const { overdue, upcoming, toasts, dismissToast, markDone, snooze } = useReminders();

  useEffect(() => {
    const user = localStorage.getItem('admin_user');
    if (user) setAdmin(JSON.parse(user));
  }, []);

  return (
    <div className={`adm-layout ${sidebarOpen ? '' : 'adm-layout--collapsed'}`}>

      {/* Sidebar */}
      <aside className="adm-sidebar">
        <div className="adm-sidebar__logo">
          <Icons.Logo />
          {sidebarOpen && <span className="adm-sidebar__logo-text">Heaven Green</span>}
        </div>

        <nav className="adm-nav">
          {NAV_ITEMS.map((item) => {
            const IconComponent = item.icon;
            return (
              <a
                key={item.path}
                href={item.path}
                className={`adm-nav__item ${current === item.path ? 'active' : ''}`}
              >
                <span className="adm-nav__icon"><IconComponent /></span>
                {sidebarOpen && <span className="adm-nav__label">{item.label}</span>}
              </a>
            );
          })}
        </nav>

        <div className="adm-sidebar__footer">
          <a href="/" className="adm-nav__item" target="_blank" rel="noreferrer">
            <span className="adm-nav__icon"><Icons.Website /></span>
            {sidebarOpen && <span className="adm-nav__label">View Website</span>}
          </a>
          <button className="adm-nav__item adm-nav__item--btn" onClick={adminLogout}>
            <span className="adm-nav__icon"><Icons.Logout /></span>
            {sidebarOpen && <span className="adm-nav__label">Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="adm-main">
        {/* Top bar */}
        <header className="adm-topbar">
          <button className="adm-topbar__toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
            <Icons.Toggle />
          </button>
          <h1 className="adm-topbar__title">{title}</h1>
          <div className="adm-topbar__right">
            <ReminderBell overdue={overdue} upcoming={upcoming} markDone={markDone} snooze={snooze} />
            <div className="adm-topbar__user">
              <span className="adm-topbar__avatar">
                {admin?.name?.charAt(0)?.toUpperCase() || 'A'}
              </span>
              <span className="adm-topbar__name">{admin?.name || 'Admin'}</span>
            </div>
          </div>
        </header>

        {/* Content */}
        <main className="adm-content">
          {children}
        </main>

      </div>

      <ReminderToast toasts={toasts} dismissToast={dismissToast} markDone={markDone} snooze={snooze} />
    </div>
  );
}

export default AdminLayout;